import React, { useEffect, useMemo, useRef } from "react";
import VideoImg from "assets/images/videoPoster.png";
import { VideoTypeEnum } from "enums/enums";

interface Props {
  source?: string;
  type?: number;
  play: boolean;
}

function Video({ source, type, play }: Props) {
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    document.querySelector("video")?.setAttribute("oncontextmenu", "return false;");
  }, []);

  const getEmbedUrl = useMemo(() => {
    // this step needs to make sure that url doesn't have space
    if (!source) return null;

    let cleanUrl = source.trim();

    // this step needs to make sure that url doesn't include ; at the end
    // link exactly like this comes from backend in case of vimeo
    if (cleanUrl.endsWith(";")) {
      cleanUrl = cleanUrl.slice(0, -1);
    }

    const autoplayParams = play ? "&autoplay=1&mute=1" : "";
    const vimeoAutoplayParams = play ? "&autoplay=1&loop=1&muted=1" : "";

    if (cleanUrl.includes("youtu.be") || cleanUrl.includes("youtube.com")) {
      const videoId = cleanUrl.split("/").pop()?.split("?")[0];
      return `https://www.youtube.com/embed/${videoId}?${autoplayParams.substring(1)}`;
    }

    if (cleanUrl.includes("vimeo.com")) {
      const videoId = cleanUrl.split("/").pop()?.split("?")[0];
      return `https://player.vimeo.com/video/${videoId}?h=37b19e0ba5&title=0&byline=0&portrait=0${vimeoAutoplayParams}`;
    }

    return null;
  }, [source, play]);

  useEffect(() => {
    if (videoRef.current && source && play) {
      videoRef.current.load();
      videoRef.current.play().catch((error) => console.error("Video play failed:", error));
    }
  }, [source, play]);

  return (
    <>
      {(() => {
        switch (type) {
          case VideoTypeEnum.YOUTUBE:
            return (
              <iframe
                width="100%"
                height="100%"
                src={getEmbedUrl || ""}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen></iframe>
            );
          case VideoTypeEnum.VIMEO:
            return (
              <iframe
                src={getEmbedUrl || ""}
                width="100%"
                height="100%"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen></iframe>
            );
          default:
            return (
              <video
                ref={videoRef}
                style={{ width: "100%", height: "100%", borderRadius: 20 }}
                poster={VideoImg}
                controls
                className="video-education-desktop"
                controlsList="nodownload"
                autoPlay={play}>
                <source src={source} type="video/mp4"></source>
              </video>
            );
        }
      })()}
    </>
  );
}

export default Video;
